class LazyVideo extends HTMLElement {
  constructor() {
    super();
    // this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
    //   rootMargin: '50px',
    //   threshold: 0.1,
    // });

    // this.video =
    //   window.matchMedia('(max-width: 767px)').matches && this.querySelector('.mobile-video-template')
    //     ? this.querySelector('.mobile-video-template').content.firstElementChild.cloneNode(true)
    //     : this.querySelector('.video-template').content.firstElementChild.cloneNode(true);

    // this.previewImage = this.querySelector('.video-preview');
    // this.video.setAttribute('preload', 'none');

    this.video =
      window.matchMedia('(max-width: 767px)').matches && this.querySelector('.mobile-video')
        ? this.querySelector('.mobile-video')
        : this.querySelector('.desktop-video');

    this.playButton = document.createElement('button');
    this.playButton.classList.add('play-button');
    this.playButton.setAttribute('aria-label', 'Play video');
    this.playButton.setAttribute('aria-pressed', 'false');

    this.playButton.addEventListener('click', this.togglePlayPause.bind(this));
    this.video.addEventListener('play', () => {
      // this.previewImage.remove();
      this.updatePlayButton(true);
    });
    this.video.addEventListener('pause', () => this.updatePlayButton(false));
  }

  connectedCallback() {
    this.appendChild(this.playButton);
    // this.observer.observe(this);
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        if (this.video.hasAttribute('autoplay')) {
          this.previewImage.remove();
        }
        this.appendChild(this.video);
        this.observer.unobserve(this);
      }
    });
  }

  playVideo() {
    const video = this.querySelector('video');
    if (video) {
      video.play();
    }
  }

  togglePlayPause() {
    if (this.video.paused) {
      this.video.play();
    } else {
      this.video.pause();
    }
  }

  updatePlayButton(isPlaying) {
    this.playButton.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
    this.playButton.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
  }
}

customElements.define('lazy-video', LazyVideo);
